module.exports = __webpack_public_path__ + "static/media/S.86471316.png";